import React, { useState } from "react";
import CustomButton from "components/CustomButton";
import classNames from "classnames";
import DefaultTeamAvatar from "assets/img/HandsColorAvatar.jpeg";

export default ({ selectGeneralTab, activeId }) => {
  const [generalTabInformation] = useState({
    id: "general",
    name: "My ReTeam",
  });

  return (
    <div
      className={classNames({
        activeMicrosoftTeam: activeId === "general" ? true : false,
        reteamTab: true,
      })}
    >
      <div>
        <img
          style={{ maxHeight: "150px", height: "100%", minHeight: "150px" }}
          className="t-cover br-6"
          src={DefaultTeamAvatar}
          alt="team-cover"
        />
      </div>
      <div>
      </div>
      <div className="reteamTabHeading">My ReTeam</div>
      <div className="reteamTabDescription">
        Personalized experience for every user to access all of their ReTeams
      </div>
      <div>
        <CustomButton
          type="button"
          name="Select"
          onClick={() => selectGeneralTab(generalTabInformation)}
          buttonClass={classNames({
            "microsoft-active-button": activeId === "general" ? true : false,
            full_w: true,
            "f-left": true,
            "outline-btn": true,
          })}
        />
      </div>
    </div>
  );
};
